import { useState, useEffect, useCallback } from "react";
import ParagraphTag from "../../reusebale/Paragraph";
import ImageTag from "../../reusebale/imageTag";
import NoData from "../../reusebale/noData";
import LeaseTableLoader from "../../skeleton-loader/lease-table";
import db from "../../../db/index.json";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import * as DataAction from "../../../store/actions/data/DataAction";
import { useSelector, useDispatch } from "react-redux";
import {
  ArrowUpDown,
  ArrowDownUp,
  Clock4,
  CircleAlert,
  CircleCheck,
  ArrowRight,
} from "lucide-react";
import BaseUrl from "../../../constants/BaseUrl";
import { convertUTCDateToLocal } from "../../../utils/utils";

const SupportShift = () => {
  const { support } = db;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [AllAllRequest, setAllResuests] = useState([]);
  const [Loading, setLoading] = useState(false);
  const { loginSuccess } = useSelector((state) => state.auth);

  // State for sorting
  const [sortConfig, setSortConfig] = useState({
    key: "lease",
    direction: "asc",
  });

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
    const sortedData = [...AllAllRequest].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === "asc" ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return direction === "asc" ? 1 : -1;
      }
      return 0;
    });
    setAllResuests(sortedData);
  };

  const [record, setRecord] = useState([]);

  // Date range state
  const [startDate, setStartDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });

  const [endDate, setEndDate] = useState(() => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    return tomorrow.toISOString().split("T")[0];
  });

  const getShiftsByDateRange = useCallback(() => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/support/getShiftsByDateRange?startDate=${startDate}&endDate=${endDate}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          setRecord(result.data);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  }, [startDate, endDate, loginSuccess?.token]);

  useEffect(() => {
    getShiftsByDateRange();
  }, [getShiftsByDateRange]);

  function getTimeDifference(checkInDate, checkOutDate) {
    const checkIn = new Date(checkInDate);
    const checkOut = new Date(checkOutDate);

    let diffInMinutes = Math.floor((checkOut - checkIn) / 60000); // Convert ms to minutes
    let hours = Math.floor(diffInMinutes / 60);
    let minutes = diffInMinutes % 60;

    return `${hours}hr : ${minutes}min`;
  }

  return (
    <div className="h-full pt-5">
      <div className="bg-white w-full h-[95%]">
        <div className="w-[95%] mx-auto h-full">
          <div className="flex items-center justify-between h-[15%]">
            <ParagraphTag
              content={support.tableHead2}
              classes="text-darkColor font-popinsSemiBold text-base pl-2 mt-2"
            />
            <div className="flex items-center gap-4 pr-2">
              <div className="flex items-center gap-2">
                <ParagraphTag
                  content="Start Date:"
                  classes="text-darkColor font-popinsMedium text-sm"
                />
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="border border-gray-300 rounded-md px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-themeColor focus:border-transparent"
                />
              </div>
              <div className="flex items-center gap-2">
                <ParagraphTag
                  content="End Date:"
                  classes="text-darkColor font-popinsMedium text-sm"
                />
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="border border-gray-300 rounded-md px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-themeColor focus:border-transparent"
                />
              </div>
            </div>
          </div>
          <div className="overflow-x-scroll w-full h-[85%] panelScroll pt-6">
            <table className="w-full ">
              <thead className="sticky top-0 bg-white">
                <tr className="border-b border-black/20">
                  <th className="w-[23%] text-left pb-2">
                    <span className="flex">
                      <ParagraphTag
                        content={support.shiftThead1}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {sortConfig.key === "lease" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("lease")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("lease")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("lease")}
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[12%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={support.shiftThead2}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {sortConfig.key === "status" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("status")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("status")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("status")}
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[20%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={support.shiftThead3}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {sortConfig.key === "propertyInfo?.propertyName" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() =>
                              requestSort("propertyInfo?.propertyName")
                            }
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() =>
                              requestSort("propertyInfo?.propertyName")
                            }
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() =>
                            requestSort("propertyInfo?.propertyName")
                          }
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[12%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={support.shiftThead4}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pl-2"
                      />
                      {sortConfig.key === "date" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("date")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("date")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("date")}
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[10%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={support.shiftThead5}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pl-2"
                      />
                      {sortConfig.key === "dueDate" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("dueDate")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("dueDate")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("dueDate")}
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[13%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content="Type"
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pl-2"
                      />
                      {sortConfig.key === "type" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("type")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("type")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("type")}
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[10%] text-right pr-4 pb-2">
                    <ParagraphTag
                      content={support.shiftThead6}
                      classes="text-darkColor/40 font-popinsSemiBold text-xs"
                    />
                  </th>
                </tr>
              </thead>
              <tbody>
                {record?.map((item) => (
                  <tr
                    key={item?._id}
                    className="hover:bg-gray-100 rounded-md cursor-pointer"
                  >
                    <td className="py-2">
                      <div className="flex items-center justify-between">
                        <div className="w-[18%] rounded-full">
                          <ImageTag
                            path="/assets/daashboard/setting-icon.png"
                            classes="w-full"
                            altText="logo"
                          />
                        </div>
                        <div className="w-[78%] cursor-pointer">
                          <ParagraphTag
                            content={`SHIFT-${(item?._id).slice(0, 10)}`}
                            classes="text-darkColor/50 font-popinsMedium text-xs"
                          />
                          <ParagraphTag
                            content={item?.shiftDate}
                            classes="text-darkColor font-popinsSemiBold text-sm"
                          />
                        </div>
                      </div>
                    </td>
                    <td className="py-2 font-popinsMedium text-darkColor text-sm">
                      <div className="flex justify-center items-center">
                        <span>
                          {(() => {
                            switch (item.status) {
                              case "Active":
                                return (
                                  <CircleAlert color="#E43B3B" size={20} />
                                );
                              case "Parts Ordered":
                                return <Clock4 color={"#FF814E"} size={20} />;
                              case "Completed":
                                return (
                                  <CircleCheck color="#01CB78" size={20} />
                                );
                              default:
                                break;
                            }
                          })()}
                        </span>
                        <span
                          className={`pl-2 ${
                            item.status === "Parts Ordered"
                              ? "text-themeColor"
                              : item.status === "In Progress"
                              ? "text-lightgray"
                              : "text-[#01CB78]"
                          }`}
                        >
                          {convertUTCDateToLocal(item?.checkInDate)}
                        </span>
                      </div>
                    </td>
                    <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">
                      <div className="flex flex-col">
                        <span className="text-darkColor/50 text-xs">
                          {item?.propId}
                        </span>
                        <span className="text-sm text-darkColor">
                          {item?.checkOutDate
                            ? convertUTCDateToLocal(item?.checkOutDate)
                            : "Missing Checkout"}
                        </span>
                      </div>
                    </td>
                    <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">
                      {item?.checkOutDate
                        ? getTimeDifference(
                            item?.checkInDate,
                            item?.checkOutDate
                          )
                        : "Not found"}
                    </td>
                    <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">
                      {item?.numberOfActiveChats}
                    </td>
                    <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">
                      {item?.type}
                    </td>
                    <td className="pt-5 2xl:pt-4 px-4 flex justify-end items-center h-full pr-8">
                      <div
                        onClick={() => {
                          navigate("/shift-detail");
                          dispatch(
                            DataAction.SelectedPrevSessionIdAction(item._id)
                          );
                        }}
                        className="flex justify-center items-center border border-themeColor w-7 h-7 rounded-md cursor-pointer"
                      >
                        <ArrowRight color="#6F6F6F" size={18} strokeWidth={2} />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {Loading && <LeaseTableLoader />}
            {record.length === 0 && !Loading && (
              <div className="w-full mt-5">
                <NoData />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportShift;
